import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import success from '../Assets/success.png';

const Success = () => {
  const location = useLocation();
  const { amount, name, orderId } = location.state || { 
    amount: '', 
    name: '', 
    orderId: '' 
  };

  const handleDownloadReceipt = async () => {
    try {
      const response = await fetch(`https://laravel-file-gen-production.up.railway.app/download-receipt_from_order/${orderId}`);
      
      if (!response.ok) {
        fetch(`https://api.sirajulhuda.com/api/v1/dms/whatsapp_receipt_when_web_download_fails?order_id=${orderId}`)
        throw new Error('You will get the receipt on WhatsApp');
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', `receipt-${orderId}-${name.replace(/\s+/g, '-')}.pdf`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error('Error downloading receipt:', error);
      alert('Failed to download receipt. Please try again.');
    }
  };

  return (
    <div className='success-bg'>
      <div className="content-status">
        <img src={success} className='successimage' alt="Success" />
        <h1 className='payment-text'>Payment Successful</h1>
        <div className='payment-details'>
          <h3 className='payment-sub'>Thank you for your payment , {name}</h3>
          <h3 className='payment-amount'>Amount Paid: ₹{amount}</h3>
          <p className='order-id'>Order ID: {orderId}</p>
        </div>
        <div className='button-container'>
          <button 
            onClick={handleDownloadReceipt}
            className='btn-recipt'
            disabled={!orderId}
          > <i class="ri-printer-line"></i>
            Download Receipt
          </button>
          <Link to='/' className='btn-try'>Back Home</Link>
        </div>
      </div>
    </div>
  );
};

export default Success;